import styled, { css } from "styled-components";

export const textParagraphXsRegular = css`
  font-size: 0.75rem;
  line-height: 150%;
  font-weight: 400;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 24px;
  text-align: left;
  padding: 1.5rem;

  @media (max-width: 767px) {
    padding: 1rem;
  }
`;

export const FormSpanError = styled.span`
  ${textParagraphXsRegular}
  color: #F3322B;
`;

export const FormSeparator = styled.div`
  width: 100%;
  height: 1px;
  background-color: #cbd5e1;
`;

export const PrivacyPolicy = styled.div`
  color: ${(props) => props.color || "var(--text-body, #475569)"};
  font-size: 0.875rem;
  line-height: 150%;
  font-weight: 400;
  margin-top: -0.1875rem;

  a {
    color: inherit;
    text-decoration: underline;

    &:hover {
      opacity: 0.8;
    }
  }
`;

export const FormMessage = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media (min-width: 768px) {
    height: 39.0625rem;
  }

  @media (max-width: 767px) {
    height: 20.3125rem;
  }
`;

export const FormMessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media (min-width: 768px) {
    max-width: 20.0625rem;
  }
`;

export const FormMessageTitle = styled.p`
  text-align: center;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 130%;
`;
